import _ from 'lodash'
import React from 'react'
import { differenceLeft } from './difference-left'
import codeService from 'data/codes'

export type Diff = {
  key: string
  value?: string|string[]
  added?:boolean
  removed?:boolean
  indent: number
  isArrayElement?: boolean
}

export function render(diffs){
  let els: JSX.Element[] = _.map(diffs, (d) => {
    let style = { color: 'gray', marginLeft: `${d.indent}em` }
    if (d.added) style.color = 'green'
    if (d.removed) style.color = 'red'
    if (d.value) {
      if (_.isArray(d.value)) {
        return (
          <div style={style}>{d.key}:
            {_.map(d.value, v => <div style={{marginLeft: `${d.indent+1}em`}}>{v}</div>)}
          </div>
        )
      }
      if (d.isArrayElement) return <div style={style}>{d.value}</div>
      return <div style={style}>{d.key}: {d.value}</div>
    }
    return <div style={style}>{d.key}</div>
  })
  return <pre style={{fontFamily: 'Roboto'}}>{els}</pre>
}

export function diff(left, right, mapper?, alwaysKeep?, alwaysDrop?){
  if (_.isEmpty(left)) left = null
  const json =
    left && right ? differenceLeft(left,right) : left || right
  // const paths = _.sortBy(_.filter(_.union(pathsOf(json), alwaysKeep), p => !_.some(alwaysDrop, ad => p.startsWith(ad))))
  const paths = _.sortBy(_.filter(_.union(pathsOf(left).concat(pathsOf(right)), alwaysKeep), p => !_.some(alwaysDrop, ad => p.startsWith(ad))))
  const codes = codeService.value()

  let items = _.flatMap(paths, path => {
    let diffs: Diff[] = []
    let lvalue = _.get(left, path)
    let rvalue = _.get(right, path)
    const key = _.last(_.split(path, '.')).replace(/(nameditem)?id$/i, '')
    const isDoLater = (x) => _.isPlainObject(x) || _.isArray(x)
    const isHead = isDoLater(lvalue) || isDoLater(rvalue)
    const isArrayElement = _.isFinite(+key)
    const isSame = _.isEqual(_.get(left, path), _.get(right, path))
    const indent = _.split(path, '.').length
    const text = mapper && mapper(key) || key
    if (isSame && !_.includes(alwaysKeep, key)) return
    if (isHead) {
      diffs.push({indent, key: text})
      return diffs
    }

    const idKey = key.toLowerCase()
    if (codes[idKey]) {
      lvalue = _.find(codes[idKey], {id: lvalue})?.code || lvalue
      rvalue = _.find(codes[idKey], {id: rvalue})?.code || rvalue
      if (typeof rvalue == 'string' && _.isFinite(+lvalue)) lvalue = ''
    }

    if (lvalue === true) lvalue = 'True'
    if (rvalue === true) rvalue = 'True'
    if (lvalue === false) lvalue = 'False'
    if (rvalue === false) rvalue = 'False'

    if (isSame) {
      diffs.push({indent, key: text, value: lvalue})
    } else {
      lvalue !== undefined && diffs.push({removed: true, indent, key: text, value: lvalue, isArrayElement});
      rvalue !== undefined && diffs.push({added: true, indent, key: text, value: rvalue, isArrayElement});
    }
    return diffs
  }).filter(x=>x)
  return items
}

function pathsOf(object) {
  if (_.isArray(object)) object = _.toPlainObject(object)
  if (!_.isPlainObject(object)) return []
  let ps: string[] = []
  for (let key of _.keys(object)) {
    ps.push(key)
    ps.push(..._.map(pathsOf(object[key]), p => `${key}.${p}`))
  }
  return ps
}